import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="pluginmanager" id="pluginmanager"></a>
    <h1 {...{
      "id": "requireuxppluginmanager"
    }}>{`require('uxp').pluginManager`}</h1>
    <p>{`To get the list of plugins in the host, used during IPC(Inter Plugin Communication)
To get an instance: `}<inlineCode parentName="p">{`require("uxp").pluginManager`}</inlineCode></p>
    <a name="pluginmanager-plugins" id="pluginmanager-plugins"></a>
    <h2 {...{
      "id": "plugins--set"
    }}>{`plugins ⇒ `}<inlineCode parentName="h2">{`Set`}</inlineCode></h2>
    <p>{`To get the current list of plugins in Plugin Manager.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Set`}</inlineCode>{` - list of Plugin objects  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      